(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('gaia-header');
    let announcement = document.querySelector('.section--announcement-bar');
    function setHeaderHeight() {
      let headerHeight = header ? header.getBoundingClientRect().height : 0;
      let announcementHeight = 0;
      if (announcement && announcement.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING) {
        // Only add if announcement is above header in DOM
        announcementHeight = announcement.getBoundingClientRect().height;
      }
      document.documentElement.style.setProperty('--header-height', `${parseInt(headerHeight + announcementHeight)}px`);
      document.documentElement.style.setProperty('--header-height-no-announcement', `${parseInt(headerHeight)}px`);
    }
    setHeaderHeight();

    var headerObserver = new ResizeObserver(setHeaderHeight);
    headerObserver.observe(header);
    if (announcement) {
      var announcementObserver = new ResizeObserver(setHeaderHeight);
      announcementObserver.observe(announcement);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
